import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import ChoiceFields from './ChoiceFields'

export const ChoiceEdit = props => (
    <Edit {...props}>
        <SimpleForm toolbar={<CustomToolbar/>}>
            <Grid container spacing={8}>
                <ChoiceFields/>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default ChoiceEdit
